/**
 * Accès à `localStorage` qui ne casse jamais.
 *
 * Le stockage peut être **indisponible** sans que rien ne le laisse deviner :
 * navigation privée sur certains navigateurs, quota atteint, cookies tiers
 * bloqués dans une iframe. Chaque accès y lève alors une exception. Un admin
 * qui plante au boot pour cette raison serait un mauvais échange : on dégrade
 * en « pas de session persistée ».
 *
 * ⚠️ Équivalent web de `expo-secure-store` côté app, à une différence près :
 * `localStorage` **n'est pas chiffré** et reste lisible par tout script de la
 * page. C'est acceptable pour un jeton d'admin sur un domaine dédié, pas pour
 * un secret durable.
 */
export function readStorage(key: string): string | null {
  try {
    return globalThis.localStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string | null): void {
  try {
    if (value === null) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, value);
  } catch {
    // Stockage indisponible : la session ne survivra pas au rechargement,
    // mais l'onglet courant reste parfaitement utilisable.
  }
}
